import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const InjuryType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Injury Type</InputLabel>
      <Select
        value={moduleValues?.['Injury Type'] ?? ''}
        label="Injury Type"
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Injury Type']: e.target.value,
          }))
        }
      >
        <MenuItem value="Closed Fracture">Closed Fracture</MenuItem>
        <MenuItem value="Open Fracture">Open Fracture</MenuItem>
        <MenuItem value="Dislocation">Dislocation</MenuItem>
        <MenuItem value="Sprain">Sprain</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default InjuryType
